<template>
    <div>
        <DetailHeader
            title="深圳睿网云联科技有限公司的云快线智能组网产品分别通过SD-WAN Ready的设备、解决方案以及服务认证"
            subTitle="2020-06-29"
        />
        <DetailBody>
            <p class="reveal-bottom">
                2020年6月2日--6月29日，深圳睿网云联科技有限公司（以下简称“睿网云联”）参加了由CCSA
                SNAI推委会（TC610）SDN集成与互通测试组发起的“SD-WAN
                Ready”测试项目，并已顺利通过该项测试。通过此次测试，表明睿网云联SD-WAN产品的技术规范性和专业性得到了充分肯定。截止目前，已有中国联通、电信国际、移动国际、华为、思科、奇安信、香港电讯等多家企业通过“SD-WAN
                Ready”项目测试。
            </p>
            <p class="reveal-bottom">
                项目测试专家组对睿网云联云快线智能组网产品进行了全面且严格的评测，验证了睿网云联的智能SD-WAN接入设备终端、云快线智能SD-WAN组网方案、云快线智能SD-WAN组网服务三项测试，这标志着睿网云联SD-WAN的解决方案、边缘设备和服务能力满足了各行业广域互联的核心应用场景和共性需求。睿网云联将进一步加快SD-WAN服务的标准化步伐，积极推动SD-WAN生态的开放发展和网络服务的灵活创新。
            </p>
            <p class="reveal-bottom">
                在本期测试中，睿网云联的云快线智能组网产品顺利通过了“SD-WAN边缘设备基准测试”并获得了设备模块证书。测试内容包括自动化部署、负载均衡、动态链路、应用识别、QoS匹配、WAN优化、线路探测、WAN接入、VPN组网、URL过滤、防火墙、主备切换、网络转发、隧道转发测试等功能。
            </p>
            <img :src="img1" alt="img1" class="reveal-bottom" />

            <p class="reveal-bottom">
                云快线智能组网产品顺利通过了“SD-WAN设备整体解决方案”并获得了方案模块的证书，测试内容包括：自动化部署、链路双活、链路质量检测、应用识别、负载均衡、动态路由、策略匹配、运维管理、Overlay拓扑变更、安全策略、URL过滤、隧道安全、隧道隔离、控制器高可靠、设备高可靠、链路高可靠。
            </p>
            <img :src="img2" alt="img2" class="reveal-bottom" />
            <p class="reveal-bottom">
                云快线智能组网产品顺利通过了“SD-WAN设备服务基准测试”并获得了服务模块的证书，测试内容包括：服务条款、服务运维能力、分级服务能力、SLA能力、服务可用性、服务计费能力、服务扩缩能力。
            </p>
            <img :src="img3" alt="img3" class="reveal-bottom" />
            <p class="reveal-bottom">
                深圳睿网云联公司时国际领先的SD-WAN方案与服务供应商，公司具有多项自主研发的技术专利。帮助企业能更高速、更便捷地连通全球各地网络。公司核心成员具有超过20年的ICT领域经验，并拥有CCIE/系统分析师/JNCIE等多名顶级技术专家为客户服务。
            </p>
            <p class="reveal-bottom">
                公司成立3年来，客户遍布世界五大洲，其中不乏知名的全球500强企业客户。
            </p>
            <img :src="img4" alt="img4" class="reveal-bottom" />
            <h3 class="reveal-bottom">
                睿网云联云快线智能SD-WAN组网技术架构：
            </h3>
            <p class="reveal-bottom">
                控制中心：<br />
                &nbsp;&nbsp; 智能选路：根据骨干网链路质量动态智能流量调度。<br />
                &nbsp;&nbsp;
                全局监控/分析：全网实时链路大数据统计与分析平台。<br />
                &nbsp;&nbsp;
                骨干网：可部署在云端、IDC，提供边缘设备接入服务，以及骨干线路流量转发。<br />
                &nbsp;&nbsp;
                边缘连接器：部署在数据中心/总部、分支的接入设备，用于连接云网络，实现用户端到端连通。<br />
            </p>
            <h3 class="reveal-bottom">云快线智能组网应用场景</h3>
            <img :src="img5" alt="img5" class="reveal-bottom" />
            <h3 class="reveal-bottom">企业广域网组网</h3>
            <p class="reveal-bottom">
                目标客户：跨区域经营公司、连锁型企业（零售/连锁/餐饮/酒店等）<br />
                需求：需要实现跨地域、跨运营商快速组网，混合网络架构、降低专线成本、基于应用进行网络资源调度、网络状态可视化监控。
            </p>
            <h3 class="reveal-bottom">SaaS访问加速</h3>
            <p class="reveal-bottom">
                目标客户：外资企业、国际协作型单位、有国际SaaS应用的企业<br />
                需求：从国内访问海外公有云SaaS服务速度慢不稳定（如Salesforce/Office365/Webex等），国际电路成本高、部署周期长
            </p>
            <h3 class="reveal-bottom">云连接</h3>
            <p class="reveal-bottom">
                目标客户：使用混合云&共有云的公司<br />
                需求：办公机构、IDC需要与公有云实现高速连接，同步数据；MPLS
                VPN无法部署连接公有云、专线成本高
            </p>
            <p class="reveal-bottom">
                云快线智能组网方案还支持丰富的网络服务层和数据接入层，现网平滑演进。
            </p>
            <img :src="img6" alt="img6" class="reveal-bottom" />
            <p class="reveal-bottom">
                在underlay层，我们支持传统互联网的Ethernet/PPPoE/MPLS等线路，并支持WiFi/LTE等多种无线协议。
            </p>
            <p class="reveal-bottom">
                Overlay层支持OSPF/BGP等动态路由协议，应用层防火墙、DPI等上层应用支持，给客户提供丰富的应用配置与监控分析。
            </p>
            <img :src="img7" alt="img7" class="reveal-bottom" />
            <p class="reveal-bottom">
                智能设备终端提供了丰富的应用层流量调度与监控。设备预置的应用库可以识别3000+主流应用，且客户可以按业务需要，基于五类元组，子定义应用类型进行自定义。
            </p>
            <p class="reveal-bottom">
                并且客户可根据具体应用进行分流、调度、实时监控。
                未来，深圳睿网云联将继续不遗余力地推动SD-WAN技术发展，研发出更稳定与高效的SD-WAN产品，为客户提供优质的网络服务。
            </p>
            <p class="reveal-bottom">
                通过此次“SD-WAN
                Ready”项目，SD-WAN项目组专家对睿网云联智能SD-WAN接入设备终端、云快线智能SD-WAN组网方案、云快线智能SD-WAN组网服务进行了全面的测试。希望更多产业链上下游的相关企业加入到“SD-WAN
                Ready”的基准测试中来，共同推进SD-WAN产业成熟落地，共建SD-WAN开放生态。
            </p>
        </DetailBody>
    </div>
</template>
<script>
import initAnimation from "../animation";
import DetailHeader from "./Header";
import DetailBody from "./Body";

export default {
    data() {
        return {
            img1: require("@/assets/images/new/1_0.png"),
            img2: require("@/assets/images/new/1_1.png"),
            img3: require("@/assets/images/new/1_2.png"),
            img4: require("@/assets/images/new/1_3.png"),
            img5: require("@/assets/images/new/1_4.png"),
            img6: require("@/assets/images/new/1_5.png"),
            img7: require("@/assets/images/new/1_6.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        DetailHeader,
        DetailBody,
    },
};
</script>
<style scoped>
/* .box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
} */
.title {
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/NewDetail/N1.vue